<template>
  <div class="qxzb-content">
    <div class="tab-box flex">
      <div
        v-for="(item, index) in xsTypeList"
        :key="index"
        class="tab-item"
        :class="{ active: xsActive === index }"
        @click="changeXsType(index)"
      >
        <span>{{ item }}</span>
      </div>
    </div>
    <div class="chart" ref="circleChart"></div>
  </div>
</template>

<script>
import { timerMixin } from "@/util/mixin/timerMixin";
import {
  findDataSaleBydataKindIdAndYearAndProvinceCode,
  findDataSaleBydataKindIdAndYear
} from "@/api/schj";
import { loadCircleChart } from "../chart/circleChart";
export default {
  mixins: [timerMixin],
  data() {
    return {
      xsTypeList: ["省内", "全国"],
      xsActive: 0,
      circleChart: null
    };
  },
  watch: {
    dataKindId: {
      handler() {
        this.getSaleData();
        this.startTimer();
      },
      immediate: true
    },
    cMonth: {
      handler() {
        this.getSaleData();
        this.startTimer();
      },
      immediate: true
    }
  },
  computed: {
    cMonth() {
      return this.$store.state.schj.cmonth;
    },
    dataKindId() {
      return this.$store.state.schj.dataKindId;
    }
  },
  mounted() {
    //电商销售占比
    this.circleChart = this.$echarts.init(this.$refs.circleChart);
    window.addEventListener("resize", () => {
      this.circleChart.resize();
    });
  },
  methods: {
    updEc() {
      this.circleChart.resize();
    },
    runs() {
      let len = this.xsTypeList.length;
      let active = Number(this.xsActive);
      if (active < len - 1) {
        active++;
      } else {
        active = 0;
      }
      this.changeXsType(active);
    },
    changeXsType(index) {
      this.xsActive = index;
      this.getSaleData();
    },
    getSaleData() {
      const fontSizes = 13;
      const widths = 10;
      const itemGaps = 10;
      if (!this.dataKindId) {
        // setTimeout(this.getSaleData(), 1200);
        return;
      }
      if (this.xsActive == 0) {
        findDataSaleBydataKindIdAndYearAndProvinceCode({
          dataKindId: this.dataKindId,
          year: this.cMonth || new Date().getFullYear(),
          provinceCode: 44
        }).then(res => {
          if (res.data.length !== 0) {
            const data = res.data.map(v => {
              v.value = Number(v.value);
              return v;
            });
            loadCircleChart(
              this.circleChart,
              data,
              fontSizes,
              widths,
              itemGaps,
              "%"
            );
          } else {
            loadCircleChart(
              this.circleChart,
              [],
              fontSizes,
              widths,
              itemGaps,
              "%"
            );
          }
        });
      } else {
        findDataSaleBydataKindIdAndYear({
          dataKindId: this.dataKindId,
          year: this.cMonth || new Date().getFullYear(),
          provinceCode: 44
        }).then(res => {
          if (res.data.length !== 0) {
            const data = res.data.map(v => {
              v.value = Number(v.value);
              return v;
            });
            loadCircleChart(
              this.circleChart,
              data,
              fontSizes,
              widths,
              itemGaps,
              "%"
            );
          } else {
            loadCircleChart(
              this.circleChart,
              [],
              fontSizes,
              widths,
              itemGaps,
              "%"
            );
          }
        });
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.qxzb-content
    height 100%
    .chart
        // height calc(100% - 38px)
    .tab-box
        position absolute
        top 40px
        right 2%
        z-index 999
        .tab-item
            color #fff
            font-size 10px
            padding-left 13px
            margin-right 20px
            position relative
            cursor pointer
            &:before
                content ' '
                // width 6px
                // height 6px
                width 12px
                height 12px
                border-radius 50%
                background #fff
                position absolute
                left 0
                top 50%
                transform translateY(-50%)
        .active
            color #0e9cff
            &:before
                background #0e9cff
</style>
